var dvp = dvp || {};
e4.search = {
    init: function () {
        if ( jQuery( '.js-e-search' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'loop' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dvp-search-result-item-product-restricted #js-e-handlebars-tmpl-dvp-search-result-item-product-prescription #js-e-handlebars-tmpl-dvp-search-result-item-product-nonprescription #js-e-handlebars-tmpl-dvp-search-result-item-product-pharmacyonly #js-e-handlebars-tmpl-dvp-search-result-item-product-controlleddrug #js-e-handlebars-tmpl-dvp-search-result-item-product-addictivesubstances #js-e-handlebars-tmpl-dvp-search-result-item-product-psychotropic #js-e-handlebars-tmpl-dvp-search-result-item-product-suppliesinstrument #js-e-handlebars-tmpl-dvp-search-result-item-product-supplementaryfeed #js-e-handlebars-tmpl-dvp-search-result-item-product-diet #js-e-handlebars-tmpl-search-result-item-page #js-e-handlebars-tmpl-dvp-search-faq #js-e-handlebars-tmpl-dvp-search-videos #js-e-handlebars-tmpl-dvp-search-supportmaterials #js-e-handlebars-tmpl-dvp-search-elearning #js-e-handlebars-tmpl-dvp-search-events #js-e-handlebars-tmpl-dvp-search-news #js-e-handlebars-tmpl-dvp-search-therapyareas' );
                e4.search.event = e4.util.registerEvents( 'getresult', 'search' );
                e4.search.bindEvents();
                e4.search.loadIndex();
                if ( e4.util.hash.get( 'search' ) !== undefined ) {
                    jQuery( '.js-e-search-modal' ).filter( ':not(.show)' ).modal( 'show' );
                }
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-search-link' ).on( 'click', function ( event ) {
            event.preventDefault();
            if ( e4.util.hash.get( 'search' ) === undefined ) {
                e4.util.hash.set( 'search' );
            }
        } );
        jQuery( '.js-e-search-modal' ).on( 'shown.bs.modal hide.bs.modal', function ( event ) {
            e4.search.handleModal( event.target, event );
        } );
        jQuery( '.js-e-search-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
            e4.search.result.get( jQuery( event.target ).find( '.js-e-search-input' ).get( 0 ) );
        } ).find( '.js-e-search-input' ).on( 'input', function ( event ) {
            e4.search.toggleInputGroupState( event.target );
            e4.util.debounce( function () {
                jQuery( event.target ).closest( '.js-e-search-form' ).triggerHandler( 'submit' );
            }, e4.settings.search.debounceDelay ).apply( this );
        } ).on( 'change', function ( event ) {
            if ( event.target.value !== '' && e4.util.hash.get( 'search' ) !== undefined ) {
                e4.util.hash.replace( 'search', event.target.value );
                jQuery( '.js-dvp-header-search-input' ).val( this.value );
            }
        } );
        jQuery( '.js-e-search-clear' ).on( 'click', function () {
            e4.search.clearInput( this );
        } );
        jQuery( window ).on( 'hashchange', function () {
            var hashSearch = e4.util.hash.get( 'search' );
            if ( hashSearch === undefined ) {
                jQuery( '.js-e-search-modal' ).filter( '.show' ).modal( 'hide' );
            }
            else {
                jQuery( '.js-e-search-modal' ).filter( ':not(.show)' ).modal( 'show' );
            }
        } );
    },
    loadIndex: function () {
        if ( e4.settings.search.result.products.show === true ) {
            jQuery.get( e4.settings.search.result.products.url + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.typeahead.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.faq.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.videos.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.therapyareas.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.premiumpages.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.supportmaterials.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.elearning.url + '?q=' + ( new Date().getTime() ) );
        }
        if ( e4.settings.search.result.pages.show === true ) {
            jQuery.get( e4.settings.search.events.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.news.url + '?q=' + ( new Date().getTime() ) );
            jQuery.get( e4.settings.search.result.pages.url + ( new Date().getTime() ) );
        }
    },
    handleModal: function ( domElm, event ) {
        var jSearchInput = jQuery( domElm ).find( '.js-e-search-input' ),
            strQuery = jSearchInput.val(),
            hashSearch = e4.util.hash.get( 'search' );
        if ( event.type === 'shown' ) {
            if ( hashSearch !== undefined && hashSearch !== '' ) {
                jSearchInput.val( hashSearch ).triggerHandler( 'input' );
            }
            else if ( strQuery !== '' ) {
                e4.util.hash.set( 'search', strQuery );
                jSearchInput.triggerHandler( 'input' );
            }
            else {
                e4.util.hash.set( 'search' );
            }
            jSearchInput.trigger( 'focus' );
        }
        else {
            jSearchInput.trigger( 'blur' );
            if ( hashSearch !== undefined ) {
                e4.util.hash.remove( 'search' );
                //console.log( 'remove on hash modal hide' );
            }
        }
    },
    toggleInputGroupState: function ( domElm ) {
        var jSearchInputGroup = jQuery( domElm ).closest( '.js-e-search-input-group' );
        if ( domElm.value === '' ) {
            jSearchInputGroup.addClass( 'is-empty' );
        }
        else {
            jSearchInputGroup.removeClass( 'is-empty' );
        }
    },
    clearInput: function ( domElm ) {
        jQuery( domElm ).closest( '.js-e-search-input-group' ).find( '.js-e-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'input' );
    },
    tracking: {
        bindEvents: function () {
            e4.search.tracking.prescriptionProducts();
            e4.search.tracking.nonPrescriptionProducts();
            e4.search.tracking.pharmacyOnlyProducts();
            e4.search.tracking.controlledDrugProducts();
            e4.search.tracking.addictiveSubstancesProducts();
            e4.search.tracking.psychotropicProducts();
            e4.search.tracking.supplementaryFeedProducts();
            e4.search.tracking.therapyAreas();
            e4.search.tracking.supportMaterials();
            e4.search.tracking.videos();
            e4.search.tracking.academyCourses();
            e4.search.tracking.faq();
            e4.search.tracking.events();
            e4.search.tracking.news();
            e4.search.tracking.content();
        },
        therapyAreas: function () {
            jQuery( '.js-dvp-search-therapy-areas' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Therapy Areas',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        prescriptionProducts: function () {
            jQuery( '.js-dvp-search-result-products-prescription' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Prescription products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        nonPrescriptionProducts: function () {
            jQuery( '.js-dvp-search-result-products-nonprescription' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Non prescription products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        pharmacyOnlyProducts: function () {
            jQuery( '.js-dvp-search-result-products-pharmacyonly' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Pharmacy only products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        controlledDrugProducts: function () {
            jQuery( '.js-dvp-search-result-products-controlleddrug' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Controlled drug products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        addictiveSubstancesProducts: function () {
            jQuery( '.js-dvp-search-result-products-addictivesubstances' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Addictive substances products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        psychotropicProducts: function () {
            jQuery( '.js-dvp-search-result-products-psychotropic' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Psychotropic products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        supplementaryFeedProducts: function () {
            jQuery( '.js-dvp-search-result-products-supplementaryfeed' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Supplementary feed products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        suppliesInstrumentProducts: function () {
            jQuery( '.js-dvp-search-result-products-suppliesinstrument' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Supplies and instrument products',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        supportMaterials: function () {
            jQuery( '.js-dvp-search-supportmaterials' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Supplementary Materials',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        videos: function () {
            jQuery( '.js-dvp-search-videos' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Videos',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        academyCourses: function () {
            jQuery( '.js-dvp-search-elearning' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Academy Courses',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        faq: function () {
            jQuery( '.js-dvp-search-faq' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Product FAQ',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        events: function () {
            jQuery( '.js-dvp-search-events' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Events',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        news: function () {
            jQuery( '.js-dvp-search-news' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'News',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        },
        content: function () {
            jQuery( '.js-e-search-result-pages' ).on( 'click', '.js-search-tracking', function () {
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'Search',
                    'eventAction': 'Content',
                    'eventLabel': jQuery( this ).data( 'tracking' ),
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        }
    },
    result: {
        get: function ( domElm ) {
            var jSearch = jQuery( domElm ).closest( '.js-e-search' ),
                arrShowResultsPromises = [];
            jSearch.find( '.js-e-search-loading-overlay' ).addClass( 'is-loading' );
            jSearch.find( '.js-dvp-search-result-success' ).addClass( 'd-none' );
            jSearch.find( '.js-dvp-search-result-loading' ).addClass( 'is-loading' );

            if ( jQuery.trim( domElm.value ) !== '' ) {
                if ( e4.settings.search.result.products.show === true ) {
                    arrShowResultsPromises.push( e4.search.result.promiseManager.productPromise( domElm ) );
                }
                if ( e4.settings.search.result.pages.show === true ) {
                    arrShowResultsPromises.push( dvp.events.search.get( domElm ) );
                    arrShowResultsPromises.push( dvp.news.search.get( domElm ) );
                    arrShowResultsPromises.push( e4.search.result.pages.get( domElm ) );
                }
            }
            else {
                if ( e4.settings.search.result.products.show === true ) {
                    arrShowResultsPromises.push( e4.search.result.products.abort() );
                    arrShowResultsPromises.push( dvp.therapyareas.search.abort() );
                    arrShowResultsPromises.push( dvp.faq.search.abort() );
                    arrShowResultsPromises.push( dvp.videos.search.abort() );
                    arrShowResultsPromises.push( dvp.supportmaterials.search.abort() );
                    arrShowResultsPromises.push( dvp.elearning.search.abort() );

                    e4.search.result.hide( domElm );
                }
                if ( e4.settings.search.result.pages.show === true ) {
                    arrShowResultsPromises.push( dvp.events.search.abort() );
                    arrShowResultsPromises.push( dvp.news.search.abort() );
                    arrShowResultsPromises.push( e4.search.result.pages.abort( domElm ) );
                }
            }
            this.promise = jQuery.when.apply( jQuery, arrShowResultsPromises ).then( function () {
                e4.search.result.show( domElm );
                e4.search.tracking.bindEvents();
            }, function () {} );
        },
        promiseManager: {
            productPromise: function ( domElm ) {
                var d = jQuery.Deferred();
                e4.search.result.products.get( domElm ).then( function () {
                    e4.search.result.promiseManager.productDependentPromises( domElm ).then( function () {
                        d.resolve();
                    }, function () {
                        d.reject();
                    } );
                }, function () {
                    d.reject();
                } );
                return d.promise();
            },
            productDependentPromises: function ( domElm ) {
                return jQuery.when(
                    dvp.therapyareas.search.get( domElm, e4.search.result.products.therapyAreaIds ),
                    dvp.faq.search.get( domElm, e4.search.result.products.rangeIds ),
                    dvp.videos.search.get( domElm, e4.search.result.products.rangeIds, e4.search.result.products.therapyAreaIds ),
                    dvp.supportmaterials.search.get( domElm, e4.search.result.products.rangeIds ),
                    dvp.elearning.search.get( domElm, e4.search.result.products.rangeIds )
                );
            }
        },
        show: function ( domElm ) {
            e4.search.result.count = e4.search.result.pages.count + e4.search.result.products.count + dvp.therapyareas.search.count + dvp.faq.search.count + dvp.videos.search.count + dvp.supportmaterials.search.count + dvp.elearning.search.count + dvp.events.search.count + dvp.news.search.count;
            jQuery( domElm ).closest( '.js-e-search-form' ).trigger( e4.search.event.getresult, {
                query: jQuery.trim( domElm.value ),
                resultCount: e4.search.result.count
            } );
            var jSearch = jQuery( domElm ).closest( '.js-e-search' );
            if ( e4.search.result.count > 0 ) {
                jSearch.find( '.js-e-search-result-container' ).addClass( 'is-active' );
            }
            else {
                jSearch.find( '.js-e-search-result-container' ).removeClass( 'is-active' );
            }
            jSearch.find( '.js-e-search-result-count' ).text( e4.search.result.count );
            jSearch.find( '.js-e-search-page-count' ).text( e4.search.result.pages.count );
            jSearch.find( '.js-e-search-product-count' ).text( e4.search.result.products.count );
            jSearch.find( '.js-e-search-loading-overlay' ).removeClass( 'is-loading' );
            jSearch.find( '.js-dvp-search-result-loading' ).removeClass( 'is-loading' );
            jSearch.find( '.js-dvp-search-result-success' ).removeClass( 'd-none' );
        },
        hide: function ( domElm ) {
            e4.search.result.count = 0;
            var jSearch = jQuery( domElm ).closest( '.js-e-search' );
            jSearch.find( '.js-e-search-result-count' ).text( e4.search.result.count );
            jSearch.find( '.js-e-search-result-container' ).removeClass( 'is-active' );
            jSearch.find( '.js-e-search-loading-overlay' ).removeClass( 'is-loading' );
            jSearch.find( '.js-dvp-search-result-loading' ).removeClass( 'is-loading' );
            jSearch.find( '.js-dvp-search-result-success' ).removeClass( 'd-none' );
            e4.search.result.products.clear( domElm );
            e4.search.result.pages.clear( domElm );
            jSearch.find( '.js-e-search-loading-overlay' ).removeClass( 'is-loading' );
        },
        products: {
            count: 0,
            rangeIds: '',
            therapyAreaIds: '',
            get: function ( domElm ) {
                e4.search.result.products.rangeIds = '';
                e4.search.result.products.therapyAreaIds = '';

                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.result.products.url + encodeURIComponent( jQuery.trim( domElm.value.toLowerCase() ) ),
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    e4.search.result.products.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                this.count = data.products.length;
                if ( this.count > 0 ) {
                    if ( !jQuery.isEmptyObject( data.products ) ) {
                        for ( var i = 0; i < data.facets.length; i++ ) {
                            var facet = data.facets[ i ];
                            if ( facet.param === 'ri' ) {
                                for ( var ri = 0; ri < facet.options.length; ri++ ) {
                                    if ( ri >= 1 ) {
                                        e4.search.result.products.rangeIds += ',';
                                    }
                                    e4.search.result.products.rangeIds += facet.options[ ri ].value;
                                }
                            }
                            if ( facet.param === 'ta' ) {
                                for ( var ta = 0; ta < facet.options.length; ta++ ) {
                                    if ( ta >= 1 ) {
                                        e4.search.result.products.therapyAreaIds += ',';
                                    }
                                    e4.search.result.products.therapyAreaIds += facet.options[ ta ].value;
                                }
                            }
                        }
                    }

                    var groupBy = function ( xs, key ) {
                        return xs.reduce( function ( rv, x ) {
                            ( rv[ x[ key ] ] = rv[ x[ key ] ] || [] ).push( x );
                            return rv;
                        }, {} );
                    };

                    var objGroupedProducts = groupBy( data.products, 'type' );

                    var jSearch = jQuery( domElm ).closest( '.js-e-search' ),
                        jDvpSearchResultProductsRestricted = jQuery( '.js-dvp-search-result-products-restricted' ),
                        jDvpSearchResultProductsPrescription = jQuery( '.js-dvp-search-result-products-prescription' ),
                        jDvpSearchResultProductsNonPrescription = jQuery( '.js-dvp-search-result-products-nonprescription' ),
                        jDvpSearchResultProductsPharmacyOnly = jQuery( '.js-dvp-search-result-products-pharmacyonly' ),
                        jDvpSearchResultProductsControlledDrug = jQuery( '.js-dvp-search-result-products-controlleddrug' ),
                        jDvpSearchResultProductsAddictiveSubstances = jQuery( '.js-dvp-search-result-products-addictivesubstances' ),
                        jDvpSearchResultProductsPsychotropic = jQuery( '.js-dvp-search-result-products-psychotropic' ),
                        jDvpSearchResultProductsSupplementaryFeed = jQuery( '.js-dvp-search-result-products-supplementaryfeed' ),
                        jDvpSearchResultProductsSuppliesInstrument = jQuery( '.js-dvp-search-result-products-suppliesinstrument' ),
                        jDvpSearchResultProductsDiet = jQuery( '.js-dvp-search-result-products-diet' ),
                        intMaxResults = ( e4.settings.search.result.pages.show === true ) ? e4.settings.search.result.products.max[ e4.util.getBreakPoint() ] : 60;

                    if ( objGroupedProducts.Prescription !== undefined && objGroupedProducts.Prescription.length > 0 ) {
                        var objPrescriptionProductsSliced = {
                                products: objGroupedProducts.Prescription.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.Prescription.length - intMaxResults
                            },
                            objPrescriptionProducts = {
                                products: objGroupedProducts.Prescription
                            };

                        jDvpSearchResultProductsPrescription.html( e4.handlebars.tmpl.dvpSearchResultItemProductPrescription( objPrescriptionProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsPrescription, objPrescriptionProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductPrescription );
                    }
                    else {
                        jDvpSearchResultProductsPrescription.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.NonPrescription !== undefined && objGroupedProducts.NonPrescription.length > 0 ) {
                        var objNonPrescriptionProductsSliced = {
                                products: objGroupedProducts.NonPrescription.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.NonPrescription.length - intMaxResults
                            },
                            objNonPrescriptionProducts = {
                                products: objGroupedProducts.NonPrescription
                            };

                        jDvpSearchResultProductsNonPrescription.html( e4.handlebars.tmpl.dvpSearchResultItemProductNonprescription( objNonPrescriptionProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsNonPrescription, objNonPrescriptionProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductNonprescription );
                    }
                    else {
                        jDvpSearchResultProductsNonPrescription.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.PharmacyOnly !== undefined && objGroupedProducts.PharmacyOnly.length > 0 ) {
                        var objPharmacyOnlyProductsSliced = {
                                products: objGroupedProducts.PharmacyOnly.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.PharmacyOnly.length - intMaxResults
                            },
                            objPharmacyOnlyProducts = {
                                products: objGroupedProducts.PharmacyOnly
                            };

                        jDvpSearchResultProductsPharmacyOnly.html( e4.handlebars.tmpl.dvpSearchResultItemProductPharmacyonly( objPharmacyOnlyProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsPharmacyOnly, objPharmacyOnlyProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductPharmacyonly );
                    }
                    else {
                        jDvpSearchResultProductsPharmacyOnly.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.ControlledDrug !== undefined && objGroupedProducts.ControlledDrug.length > 0 ) {
                        var objControlledDrugProductsSliced = {
                                products: objGroupedProducts.ControlledDrug.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.ControlledDrug.length - intMaxResults
                            },
                            objControlledDrugProducts = {
                                products: objGroupedProducts.ControlledDrug
                            };

                        jDvpSearchResultProductsControlledDrug.html( e4.handlebars.tmpl.dvpSearchResultItemProductControlleddrug( objControlledDrugProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsControlledDrug, objControlledDrugProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductControlleddrug );
                    }
                    else {
                        jDvpSearchResultProductsControlledDrug.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.AddictiveSubstances !== undefined && objGroupedProducts.AddictiveSubstances.length > 0 ) {
                        var objAddictiveSubstancesProductsSliced = {
                                products: objGroupedProducts.AddictiveSubstances.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.AddictiveSubstances.length - intMaxResults
                            },
                            objAddictiveSubstancesProducts = {
                                products: objGroupedProducts.AddictiveSubstances
                            };

                        jDvpSearchResultProductsAddictiveSubstances.html( e4.handlebars.tmpl.dvpSearchResultItemProductAddictivesubstances( objAddictiveSubstancesProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsAddictiveSubstances, objAddictiveSubstancesProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductAddictivesubstances );
                    }
                    else {
                        jDvpSearchResultProductsAddictiveSubstances.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.Psychotropic !== undefined && objGroupedProducts.Psychotropic.length > 0 ) {
                        var objPsychotropicProductsSliced = {
                                products: objGroupedProducts.Psychotropic.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.Psychotropic.length - intMaxResults
                            },
                            objPsychotropicProducts = {
                                products: objGroupedProducts.Psychotropic
                            };

                        jDvpSearchResultProductsPsychotropic.html( e4.handlebars.tmpl.dvpSearchResultItemProductPsychotropic( objPsychotropicProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsPsychotropic, objPsychotropicProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductPsychotropic );
                    }
                    else {
                        jDvpSearchResultProductsPsychotropic.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.SupplementaryFeed !== undefined && objGroupedProducts.SupplementaryFeed.length > 0 ) {
                        var objSupplementaryFeedProductsSliced = {
                                products: objGroupedProducts.SupplementaryFeed.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.SupplementaryFeed.length - intMaxResults
                            },
                            objSupplementaryFeedProducts = {
                                products: objGroupedProducts.SupplementaryFeed
                            };

                        jDvpSearchResultProductsSupplementaryFeed.html( e4.handlebars.tmpl.dvpSearchResultItemProductSupplementaryfeed( objSupplementaryFeedProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsSupplementaryFeed, objSupplementaryFeedProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductSupplementaryfeed );
                    }
                    else {
                        jDvpSearchResultProductsSupplementaryFeed.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.SuppliesInstrument !== undefined && objGroupedProducts.SuppliesInstrument.length > 0 ) {
                        var objSuppliesInstrumentProductsSliced = {
                                products: objGroupedProducts.SuppliesInstrument.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.SuppliesInstrument.length - intMaxResults
                            },
                            objSuppliesInstrumentProducts = {
                                products: objGroupedProducts.SuppliesInstrument
                            };

                        jDvpSearchResultProductsSuppliesInstrument.html( e4.handlebars.tmpl.dvpSearchResultItemProductSuppliesinstrument( objSuppliesInstrumentProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsSuppliesInstrument, objSuppliesInstrumentProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductSuppliesinstrument );
                    }
                    else {
                        jDvpSearchResultProductsSuppliesInstrument.addClass( 'is-empty' ).html( '' );
                    }
                    if ( objGroupedProducts.Diet !== undefined && objGroupedProducts.Diet.length > 0 ) {
                        var objDietProductsSliced = {
                                products: objGroupedProducts.Diet.slice( 0, intMaxResults ),
                                showMoreCount: objGroupedProducts.Diet.length - intMaxResults
                            },
                            objDietProducts = {
                                products: objGroupedProducts.Diet
                            };
                        jDvpSearchResultProductsDiet.html( e4.handlebars.tmpl.dvpSearchResultItemProductDiet( objDietProductsSliced ) );
                        e4.search.result.products.toggleShowAllLink( jDvpSearchResultProductsDiet, objDietProducts, intMaxResults, e4.handlebars.tmpl.dvpSearchResultItemProductDiet );
                    }
                    else {
                        jDvpSearchResultProductsDiet.addClass( 'is-empty' ).html( '' );
                    }
                    if(data.showProducts === false)
                    {
                        jDvpSearchResultProductsRestricted.html( e4.handlebars.tmpl.dvpSearchResultItemProductRestricted( data.showProducts ) );
                    }
                    else {
                        jDvpSearchResultProductsRestricted.addClass( 'is-empty' ).html( '' );
                    }
                    jSearch.find( '.js-e-search-result-products' ).removeClass( 'is-empty' );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-e-search-result-products' ).attr( 'id' ) );

                }
                else {
                    e4.search.result.products.clear( domElm );
                }
            },
            clear: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-e-search-result-products' ).addClass( 'is-empty' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-e-search-result-products' ).attr( 'id' ) );
            },
            toggleShowAllLink: function ( domElm, data, intMaxResults, handlebarTemplate ) {
                var jShowAllLink = domElm.find( '.js-e-search-products-show-all' );
                if ( data.products.length > intMaxResults ) {
                    jShowAllLink.find( 'a' ).attr( 'href', e4.settings.search.result.products.showAllLink ).on( 'click', {
                        'domElm': domElm,
                        'feed': data,
                        'handlebarTemplate': handlebarTemplate
                    }, e4.search.result.products.showAll );
                }
                else {
                    jShowAllLink.addClass( 'd-none' );
                    jShowAllLink.find( 'a' ).off( 'click', e4.search.result.products.showAll );
                }
            },
            showAll: function ( event ) {
                event.preventDefault();
                if ( event.data !== undefined && event.data.feed.products.length > 0 ) {
                    var jSearch = event.data.domElm;
                    jSearch.html( event.data.handlebarTemplate( event.data.feed ) ).removeClass( 'is-empty' );
                    jSearch.find( '.js-e-search-products-show-all' ).addClass( 'd-none' );
                }
            }
        },
        pages: {
            count: 0,
            get: function ( domElm ) {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    this.jqXHR.abort();
                }
                this.jqXHR = jQuery.ajax( {
                    url: e4.settings.search.result.pages.url + encodeURIComponent( jQuery.trim( domElm.value.toLowerCase() ) ),
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } );
                this.jqXHR.done( function ( data ) {
                    e4.search.result.pages.update( domElm, data );
                } );
                return this.jqXHR;
            },
            abort: function () {
                if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                    return this.jqXHR.abort();
                }
                return jQuery.Deferred().reject();
            },
            update: function ( domElm, data ) {
                this.count = data.pages.length;
                if ( this.count > 0 ) {
                    var jSearch = jQuery( domElm ).closest( '.js-e-search' );
                    jSearch.find( '.js-e-search-result-pages' ).html( e4.handlebars.tmpl.searchResultItemPage( data ) ).removeClass( 'is-empty' );
                    dvp.search.menu.show( jQuery( jSearch ).find( '.js-e-search-result-pages' ).attr( 'id' ) );
                }
                else {
                    e4.search.result.pages.clear( domElm );
                }
            },
            clear: function ( domElm ) {
                jQuery( domElm ).closest( '.js-e-search' ).find( '.js-e-search-result-pages' ).addClass( 'is-empty' ).html( '' );
                dvp.search.menu.hide( jQuery( domElm ).closest( '.js-e-search' ).find( '.js-e-search-result-pages' ).attr( 'id' ) );
            }
        }
    }
};
